var render, staticRenderFns
import script from "./DashboardChartPie.vue?vue&type=script&lang=js"
export * from "./DashboardChartPie.vue?vue&type=script&lang=js"
import style0 from "./DashboardChartPie.vue?vue&type=style&index=0&id=bbb646a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports